import Navbar from "@/components/Navbar";
import Studio from "@/components/studio/Studio";

export default function StudioPage() {
  return (
    <main className="min-h-screen bg-[#0b111c]">
      <Navbar />
      <Studio />
    </main>
  );
}
